import { SaveIcon } from "lucide-react";

import { JobForm } from "@/components";

import { useUpdateJob } from "@/hooks/mutations";
import { Job } from "@/types";

export const JobEdit = ({
  className,
  job,
}: {
  className?: string;
  job: Job;
}) => {
  const { mutate: updateJob } = useUpdateJob();

  return (
    <JobForm
      className={className}
      job={job}
      mutationFn={updateJob}
      submitButtonIcon={<SaveIcon className="h-4 w-4" />}
      submitButtonText="Update job"
    />
  );
};
